module.exports = __webpack_public_path__ + "img/blurmap-VARILUX-E-SERIES_full_white.589c8988.png";